import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { pushFormActionStack, updateElement, updateElementOnUndoRedo } from "../../../../../../stateManager/store/formCreation_v2/actions";
import { getValue, getComponents } from "../../helpers";
import { myRedoStack, myUndoStack } from "../../stack/Stack";

const DEFAULT_BORDER_PATH: string = "properties.styles.common.border";
const DEFAULT_BORDER_PATH_V3: string = "properties.styles.$deviceType.border";


type Props = {
  label: string;
  isCheckedIn: boolean;
  defaultValue?: string;
}

export function Border(props: Props) {
  const dispatch = useDispatch();
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue, label } = props;
  const [oldValue, setOldValue] = useState<string>("");
  const [value, setValue] = useDebouncedAction(defaultValue, 500 || "");
  const component = components[selectedElementId];
  useEffect(() => {
    if (isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_BORDER_PATH_V3.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      } else if (computedStyles.borderWidth) {
        const computedValue = parseInt(computedStyles.borderWidth, 10).toString();
        setValue(computedValue)
        setOldValue(computedValue)
      }
    } else if (!isCoreV3 && component) {
      const previousValue = getValue(component, DEFAULT_BORDER_PATH.split("."), deviceType);
      if (previousValue) {
        setValue(previousValue)
        setOldValue(previousValue)
      }
    }
    // eslint-disable-next-line
  }, [isCoreV3, component, deviceType, computedStyles])

  const onChange = (path: string, value: string) => {

    myUndoStack.push({
      id: selectedElementId,
      path,
      value: oldValue,
      label: "",
      properties: {},
      type: "",
      fields: []
    })
    myRedoStack.clear();
    dispatch(updateElement({
      id: selectedElementId,
      path,
      value
    }))
    dispatch(pushFormActionStack({
      undo: () => {
        const poppedElement = myUndoStack.pop();
        if (poppedElement) {
          myRedoStack.push({ ...poppedElement, value })
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: poppedElement.path,
            value: poppedElement.value,
            increment: -1
          }))
        }
      },
      redo: () => {
        const poppedElement = myRedoStack.pop();
        if (poppedElement) {
          myUndoStack.push({ ...poppedElement, value: oldValue });
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: poppedElement.path,
            value: poppedElement.value,
            increment: 1
          }))
        }
      }
    }))

    setOldValue(value);
  }

  return (
    <div className="panel-div">
      <label
        htmlFor="horizontal"
        className="panel-label"
      >
        {label}
      </label>
      <input
        style={{ cursor: !isCheckedIn ? "not-allowed" : "auto" }}
        disabled={!isCheckedIn}
        type="number"
        min="0"
        id="border"
        value={value}
        className="panel-input"
        placeholder="Enter border width"
        onChange={e => {
          const changeValue = e.target.value;
          const value = changeValue ? Number(changeValue) > 0 ? changeValue : "0" : changeValue;
          setValue(value, () => onChange(isCoreV3 ? `properties.styles.$deviceType.border` : `properties.styles.common.border`, value))
        }}
      />
    </div>
  )
}